import Vue from 'vue';
import Vuex from 'vuex';
import Blog from '@/services/BlogAPI';

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		loading: false,
		blogs: [],
		currentBlog: {},
	},
	mutations: {
		setBlogs(state, blogs) {
			state.blogs = blogs;
		},
		setCurrentBlog(state, blog) {
			state.currentBlog = blog;
		},
		setLoading(state, newLoadingState) {
			state.loading = newLoadingState;
		},
	},
	actions: {
		getBlogs({ commit }) {
			commit('setLoading', true);

			return Blog.get('posts').then((blogs) => {
				commit('setBlogs', blogs);
				commit('setLoading', false);
			});
		},
		getBlog({ commit }, blogID) {
			commit('setLoading', true);

			return Blog.get(`posts/${blogID}`).then((blog) => {
				commit('setCurrentBlog', blog);
				commit('setLoading', false);
			});
		},
	},
});
